import styled from '@emotion/styled';

export const ButtonsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: 0 1px !important;
  gap: 6px;
`;

export const ButtonItem = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: auto;
  height: 30px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: ${({ active }) => (active ? `1px solid #000` : `1px solid #AFAFAF`)};
  border-radius: 4px;
  background: ${({ active, theme }) => (active ? theme.colors.light : 'none')};
  outline: none;
  outline: ${({ active }) => (active ? '#000 solid 1px' : 'none')};
`;
